import React from 'react';
import { Navigate, useParams } from 'react-router-dom';
import { getDefaultRankingSubcategory } from '@utils/sports';

/** Redirect legacy /coach/my-rankings/:sport/:categoryId URLs to the new evaluation flow. */
const CoachMyRankingsLegacyRedirect: React.FC = () => {
  const { sport, categoryId } = useParams<{ sport: string; categoryId: string }>();
  const safeSport = sport || 'Badminton';
  const safeCategory = categoryId || 'self-evaluation';
  const subcategory = getDefaultRankingSubcategory(safeSport);
  const evalType = ['self-evaluation', 'coach-academy', 'practical-test'].includes(safeCategory)
    ? safeCategory
    : 'self-evaluation';
  const target = `/coach/ranking-evaluation/${encodeURIComponent(subcategory)}?sport=${encodeURIComponent(safeSport)}&level=beginner&eval=${encodeURIComponent(evalType)}`;
  return <Navigate to={target} replace />;
};

export default CoachMyRankingsLegacyRedirect;
